// extracted by mini-css-extract-plugin
export var lg = "992";
export var md = "768";
export var mutedColor = "gray";
export var primaryColor = "#00b2ff";
export var primaryFont = "Nexa";
export var primaryFontHeavy = "NexaHeavy";
export var secondaryColor = "#00fff0";
export var secondaryFont = "Inter";
export var sm = "576";
export var tertiaryColor = "#008ecc";
export var xl = "1440";
export var xs = "425";